export enum OnlineIndicatorSize {
  SMALL = 'small',
  MID = 'mid',
  LARGE = 'large',
  ACTIVITY_STATUS = 'activity_status',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
}
